import { isMockMode, post, simulateDelay } from "../api";

export interface licenceIdProp {
	licenceId: string;
}

export const resendLicenceInvite = ({ licenceId }: licenceIdProp) => {
	if (isMockMode()) {
		const testData = { success: true };
		return simulateDelay(1000, () => testData);
	}

	return post(
		`licences/resendInvitation`,
		{ licenceId },
		{
			successMessage: "Successfully resent licence invitation",
		}
	);
};
